/**
 * Created by apokdev on 6/6/17.
 */
import React, {Component} from "react";
import {Link} from "react-router-dom";
import {getJSON} from "../constants/network";
import {getCurrentEstado, hideHeader} from "../constants/functions";
import routes from "../constants/routes";
import Vacio from "./Vacio";
import BreadCrumb from "./Breadcrumbs";
import Regiones from "./Regiones";
import MenuTipoPoi from "./MenuTipoPoi";
import ListaPoi from "./ListaPoi";

let queryString = require('query-string');
let ReactBootstrap = require('react-bootstrap');
let MenuItem = ReactBootstrap.MenuItem;
let DropdownButton = ReactBootstrap.DropdownButton;

const pagina = 1;
const items = 10;

export default class extends Component{
    constructor(props){
        super(props);
        this.state = {
            estados: [],
            sectores: [],
            tipos: [],
            pois: [],
            estado:{
                nombre: '',
                region:{
                    nombre: '',
                    slug: ''
                }
            }
        };

        this.cambiarEstado = this.cambiarEstado.bind(this);
        this.cambiarTipoPoi = this.cambiarTipoPoi.bind(this);
        this.cambiarSector = this.cambiarSector.bind(this);
    }

    getDataEstado(props){
        if(props.match.params.estado !== "_") {
            getJSON(routes.estadoBy + "/" + props.match.params.estado)
                .then(result => {
                    this.setState({
                        estado: result.data
                    })
                });
        }else{
            getJSON(routes.regionAll)
                .then(regionesResult => {
                    return getCurrentEstado(regionesResult.data);
                })
                .then( estadoResult => {
                    this.props.history.push(`/estado/${estadoResult}/pois`);
                })
                .catch( estadoError => {
                    this.props.history.push(`/estado/${estadoError}/pois`);
                });
        }
    }
    getListaEstadosSectores(){
        getJSON(routes.estadoBy)
            .then(result => {
                this.setState({
                    estados: result.data.estados,
                    sectores: result.data.sectores,
                })
            });
    }
    getListaTiposPoi(props){
        let urlTipos = routes.estadoBy+"/"+props.match.params.estado+"/tipospoi?items=9999";
        if(props.match.params.sector){
            urlTipos = routes.sectorById+props.match.params.sector;
        }
        getJSON(urlTipos)
            .then(result => {
                this.setState({
                    tipos: (props.match.params.sector)?result.data.pois:result.data
                })
            });
    }
    getListaPois(props){
        let query = queryString.parse(props.location.search);

        let page = query.pagina || pagina;
        let item = query.items || items;

        let nextPage = parseInt(page,10) + 1;
        let urlCurrentPage = routes.estadoBy+"/"+props.match.params.estado+"/"+props.match.params.tipopoi;
        if(props.match.params.sector){
            urlCurrentPage = routes.sectorById+props.match.params.sector+"/pois";
            if(props.match.params.tipopoi){
                urlCurrentPage += "/"+props.match.params.tipopoi;
            }
        }
        let urlNextPage = urlCurrentPage;
        urlCurrentPage  += "?items="+item+"&page="+page;
        urlNextPage += "?items="+item+"&page="+nextPage;
        getJSON(urlCurrentPage)
            .then(result => {
                this.setState({
                    pois: result.data.pois,
                    publicidad: result.data.publicidad
                });
            });
        getJSON(urlNextPage)
            .then(result => {
                this.setState({
                    anterior: page > 1,
                    siguiente: result.data.pois.length > 0
                });
            })
    }
    getSector(props){
        if(props.match.params.sector){
            getJSON(routes.sectorById+props.match.params.sector)
                .then(result => {
                    this.setState({
                        sector: result.data
                    })
                });
        }else{
            this.setState({
                sector: null
            });
        }
    }
    update(props){
        this.getDataEstado(props);
        this.getListaEstadosSectores();
        this.getListaTiposPoi(props);
        this.getListaPois(props);
        this.getSector(props);
    }
    cambiarTipoPoi(event){
        let url = "/estado/" + this.state.estado.nombre;
        if(this.props.match.params.sector){
            url += "/sector/" + this.props.match.params.sector;
        }
        this.props.history.push(url + "/" + event.target.value);
        // window.document.location = "/estado/" + this.state.estado.nombre + "/" + event.target.value;
    }
    cambiarSector(sector){
        if(sector !== "") {
            this.props.history.push("/estado/" + this.state.estado.nombre + "/sector/" + sector);
            // document.location = "/estado/" + this.state.estado.nombre + "/sector/" + sector;
        }else{
            this.props.history.push("/estado/" + this.state.estado.nombre + "/pois");
            // document.location = "/estado/" + this.state.estado.nombre + "/pois";
        }
    }
    cambiarEstado(estado){
        this.props.history.push("/estado/" + estado + "/pois");
        // document.location = "/estado/" + estado + "/pois";
    }

    componentWillReceiveProps(nextProps){
        let query = queryString.parse(this.props.location.search);
        let nextQuery = queryString.parse(nextProps.location.search);
        if(nextProps.match.params.tipopoi !== this.props.match.params.tipopoi ||
                query.items !== nextQuery.items || query.pagina !== nextQuery.pagina
        ){
            this.setState({
                pois: [],
            }, () => {
                this.getListaPois(nextProps);
            })
        }
        if(nextProps.match.params.estado !== this.props.match.params.estado ||
            nextProps.match.params.sector !== this.props.match.params.sector) {
            this.setState({
                estado: null,
                sector: null,
                tipos: [],
                pois: null,
                anterior: false,
                siguiente: false
            });
            this.update(nextProps);
        }
    }
    componentDidMount(){
        hideHeader();
        this.update(this.props);
    }
    componentDidUpdate(){
        hideHeader();
    }
    render(){
        let _this = this;
        let baseUrl = "/estado/"+this.props.match.params.estado;

        let showSectorInPois = true;
        let showRutaInPois = true;

        if(this.props.match.params.sector){
            baseUrl += "/sector/"+this.props.match.params.sector;
            showSectorInPois = false;
        }

        let baseUrlMenuTipoPoi = baseUrl;

        if(this.props.match.params.tipopoi) {
            baseUrl += "/" + this.props.match.params.tipopoi;
        }


        let query = queryString.parse(this.props.location.search);
        let page = query.pagina || pagina;
        let item = query.items || items;

        let nextPage = parseInt(page, 10) + 1;
        let prevPage = parseInt(page, 10) - 1;

        let nombreSector = "Todas";
        if(this.state.sector){
            nombreSector = this.state.sector.nombre;
            if(nombreSector.length > 25){
                nombreSector = nombreSector.substring(0,25)+"...";
            }
        }

        if(this.state.estado){
            let hayAnterior = this.state.anterior;
            let haySiguiente = this.state.siguiente;

            let breadcrumbs = [
                {url: `/#/estado/${this.state.estado.nombre}`, text: this.state.estado.nombre}
            ];

            if(this.state.sector){
                breadcrumbs.push({url: `/#/estado/${_this.state.estado.nombre}/sector/${_this.state.sector.slug}`,text: this.state.sector.nombre});
            }

            if(this.props.match.params.tipopoi && this.state.pois){
                let tipoText = "Puntos de Interés";
                if(this.props.match.params.tipopoi!=="pois" && this.state.pois.length) {
                    tipoText = this.state.pois[0].tipo.nombre;
                }
                breadcrumbs.push({url: null, text: tipoText});
            }

            return (<div>
                <div id="cambio-sector" className={this.state.estado.region.slug}>
                    <div className="contenedor-sector">
                        <BreadCrumb links={breadcrumbs}/>
                        <div className="pull-right" id="botones_cambiar_localidad">
                            <DropdownButton title={`Estado: ${this.props.match.params.estado}`} id="dropdownEstado">
                                {
                                    _this.state.estados.map(function(estado){
                                        return (
                                            <MenuItem key={`${estado}2`} eventKey={`${estado}`} onSelect={_this.cambiarEstado}>
                                                {estado}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </DropdownButton>
                            <DropdownButton id="dropdownSector" title={`Localidad: ${nombreSector}`} pullRight>
                                <MenuItem eventKey={""} onSelect={this.cambiarSector}>Todas</MenuItem>
                                {
                                    _this.state.sectores.filter(function(sector){
                                        return sector.estado === _this.state.estado.nombre;
                                    }).map(function(data){
                                        return (
                                            <MenuItem key={data.id} eventKey={data.slug} onSelect={_this.cambiarSector}>
                                                {data.nombre}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </DropdownButton>

                        </div>
                    </div>
                </div>
                <div className="contenedor-menu-tipo-poi">
                    <div className="contenedor-sector" id="container_menu_tipo_poi">
                        {
                            (function(){
                                if(_this.state.tipos){
                                    return <MenuTipoPoi
                                        tipos={_this.state.tipos}
                                        region={_this.state.estado.region.slug}
                                        elegido={_this.props.match.params.tipopoi}
                                        baseUrl={baseUrlMenuTipoPoi}
                                        extraLink={{url: `/estado/${_this.state.estado.nombre}/rutas/_` ,texto: "Rutas"}}
                                        funcionCambiarTipoPoi={_this.cambiarTipoPoi}
                                    />;
                                }
                            })()
                        }

                    </div>
                </div>
                <div className="contenedor-sector">
                    {
                        (function(){
                            if(_this.state.pois && _this.state.pois.length){
                                return (<ListaPoi
                                    pois={_this.state.pois}
                                    publicidad={_this.state.publicidad}
                                    showSector={showSectorInPois}
                                    showRuta={showRutaInPois}
                                />);
                            }else {
                                return (<Vacio/>);
                            }
                        })()
                    }
                    <div className="col-sm-9 col-sm-offset-3">
                        <nav>
                            <ul className = "pager">
                                {
                                    (function(){
                                        if(hayAnterior){
                                            return (
                                                <li className="previous">
                                                    <Link to={`${baseUrl}?items=${item}&pagina=${prevPage}`} onClick={_this.scroll}>
                                                        Anterior
                                                    </Link>
                                                </li>
                                            )
                                        }
                                        return <span/>
                                    })()
                                }
                                {
                                    (function(){
                                        if(haySiguiente) {
                                            return (
                                                <li className="next">
                                                    <Link to={`${baseUrl}?items=${item}&pagina=${nextPage}`} onClick={_this.scroll}>
                                                        Siguiente
                                                    </Link>
                                                </li>
                                            )
                                        }
                                        return <span/>
                                    })()
                                }
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="include-region">
                    <Regiones completo={false}/>
                </div>
            </div>)
        }
        return <Vacio/>;
    }
}


// WEBPACK FOOTER //
// ./src/components/PoisEstado.js